/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    DistributorReport = "murn:odr:lookup/DocumentCategory/DistributorReport",
  }

  export enum DocumentType {
    SoldDonatedTransferedSupport = "murn:odr:lookup/DocumentType/SoldDonatedTransferedSupport",
    ExportedSupport = "murn:odr:lookup/DocumentType/ExportedSupport",
  }

  export enum DistributorReportFrequency {
    Monthly = "murn:odr:lookup/DistributorReportFrequency/Monthly",
    SemiAnnual = "murn:odr:lookup/DistributorReportFrequency/SemiAnnual",
  }

  export enum PaymentStatus {
    Paid = "murn:odr:lookup/PaymentStatus/Paid",
    Due = "murn:odr:lookup/PaymentStatus/Due",
  }
  export enum ReportFrequency {
    Monthly = "murn:odr:lookup/ReportFrequency/Monthly",
    SemiAnnual = "murn:odr:lookup/ReportFrequency/SemiAnnual",
  }

  export enum ReportStatus {
    Scheduled = "murn:odr:lookup/ReportStatus/Scheduled",
    Draft = "murn:odr:lookup/ReportStatus/Draft",
    Submitted = "murn:odr:lookup/ReportStatus/Submitted",
    Approved = "murn:odr:lookup/ReportStatus/Approved",
    PastDue = "murn:odr:lookup/ReportStatus/PastDue",
  }

  export enum ReportType {
    DistributorReport = "murn:odr:lookup/ReportType/DistributorReport",
    DistributorReportAmendment = "murn:odr:lookup/ReportType/DistributorReportAmendment",
  }

  export enum ContainerMaterialType {
    Aluminum = "murn:odr:lookup/ContainerMaterialType/Aluminum",
    BiMetal = "murn:odr:lookup/ContainerMaterialType/BiMetal",
    PlasticPETE = "murn:odr:lookup/ContainerMaterialType/PlasticPETE",
    PlasticHDPE = "murn:odr:lookup/ContainerMaterialType/PlasticHDPE",
    Glass = "murn:odr:lookup/ContainerMaterialType/Glass",
  }

  // export enum State {
  //   AK = "murn:odr:lookup/State/AK",
  //   AL = "murn:odr:lookup/State/AL",
  //   AR = "murn:odr:lookup/State/AR",
  //   AS = "murn:odr:lookup/State/AS",
  //   AZ = "murn:odr:lookup/State/AZ",
  //   CA = "murn:odr:lookup/State/CA",
  //   CO = "murn:odr:lookup/State/CO",
  //   CT = "murn:odr:lookup/State/CT",
  //   DC = "murn:odr:lookup/State/DC",
  //   DE = "murn:odr:lookup/State/DE",
  //   FL = "murn:odr:lookup/State/FL",
  //   GA = "murn:odr:lookup/State/GA",
  //   GU = "murn:odr:lookup/State/GU",
  //   HI = "murn:odr:lookup/State/HI",
  //   IA = "murn:odr:lookup/State/IA",
  //   ID = "murn:odr:lookup/State/ID",
  //   IL = "murn:odr:lookup/State/IL",
  //   IN = "murn:odr:lookup/State/IN",
  //   KS = "murn:odr:lookup/State/KS",
  //   KY = "murn:odr:lookup/State/KY",
  //   LA = "murn:odr:lookup/State/LA",
  //   MA = "murn:odr:lookup/State/MA",
  //   MD = "murn:odr:lookup/State/MD",
  //   ME = "murn:odr:lookup/State/ME",
  //   MI = "murn:odr:lookup/State/MI",
  //   MN = "murn:odr:lookup/State/MN",
  //   MO = "murn:odr:lookup/State/MO",
  //   MP = "murn:odr:lookup/State/MP",
  //   MS = "murn:odr:lookup/State/MS",
  //   MT = "murn:odr:lookup/State/MT",
  //   NC = "murn:odr:lookup/State/NC",
  //   ND = "murn:odr:lookup/State/ND",
  //   NE = "murn:odr:lookup/State/NE",
  //   NH = "murn:odr:lookup/State/NH",
  //   NJ = "murn:odr:lookup/State/NJ",
  //   NM = "murn:odr:lookup/State/NM",
  //   NV = "murn:odr:lookup/State/NV",
  //   NY = "murn:odr:lookup/State/NY",
  //   OH = "murn:odr:lookup/State/OH",
  //   OK = "murn:odr:lookup/State/OK",
  //   OR = "murn:odr:lookup/State/OR",
  //   PA = "murn:odr:lookup/State/PA",
  //   PR = "murn:odr:lookup/State/PR",
  //   RI = "murn:odr:lookup/State/RI",
  //   SC = "murn:odr:lookup/State/SC",
  //   SD = "murn:odr:lookup/State/SD",
  //   TN = "murn:odr:lookup/State/TN",
  //   TX = "murn:odr:lookup/State/TX",
  //   UT = "murn:odr:lookup/State/UT",
  //   VT = "murn:odr:lookup/State/VT",
  //   VA = "murn:odr:lookup/State/VA",
  //   VI = "murn:odr:lookup/State/VI",
  //   WA = "murn:odr:lookup/State/WA",
  //   WI = "murn:odr:lookup/State/WI",
  //   WV = "murn:odr:lookup/State/WV",
  //   WY = "murn:odr:lookup/State/WY",
  //   AB = "murn:odr:lookup/State/AB",
  //   BC = "murn:odr:lookup/State/BC",
  //   MB = "murn:odr:lookup/State/MB",
  //   NB = "murn:odr:lookup/State/NB",
  //   NL = "murn:odr:lookup/State/NL",
  //   NS = "murn:odr:lookup/State/NS",
  //   ON = "murn:odr:lookup/State/ON",
  //   PE = "murn:odr:lookup/State/PE",
  //   QC = "murn:odr:lookup/State/QC",
  //   SK = "murn:odr:lookup/State/SK",
  // }
}
